import IbProgramExceptionsTable from './IbProgramExceptionsTable';

export default IbProgramExceptionsTable;
